import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  whMetaDocksList: [],
  whMetaLeavesList: [],
  whMetaBreaksList: [],
  whMetaCapacityList: [],
  whMetaTimeslotList: [],
  operationObj: {},
  arrangeOrder: "asc",
  arrangeKey: "CreatedOn",
  preCheckList: [],
  // Pagination metadata for the preCheckList (conflict appointments)
  preCheckPagination: {
    totalElements: 0,
    pageNo: 1,
    limit: 10,
    totalPages: 0,
  },
  lastPreCheckObj: {},
  dockConflictObj: {},
  isLoading: false,
  dockTypeList: [],
  capacityManagementList: [],
  massCancelReasonList: [],
};

export const WhMetaDataReducerSlice = createSlice({
  name: "whMetaDataReducerSlice",
  initialState,
  reducers: {
    getWhMetaDockList: (state, action) => {
      state.whMetaDocksList = action.payload;
    },
    getWhMetaLeavesList: (state, action) => {
      state.whMetaLeavesList = action.payload;
    },
    getWhMetaBreaksList: (state, action) => {
      state.whMetaBreaksList = action.payload;
    },
    getWhMetaCapacityList: (state, action) => {
      state.whMetaCapacityList = action.payload;
    },
    getWhMetaTimeslotList: (state, action) => {
      state.whMetaTimeslotList = action.payload;
    },
    updateOperationObj: (state, action) => {
      state.operationObj = action.payload;
    },
    updateTableData: (state, action) => {
      const { drillDownReport, arrange, key } = action.payload;
      state[key] = drillDownReport;
      state.arrangeKey = arrange.key;
      state.arrangeOrder = arrange.order;
    },
    updatePreCheckList: (state, action) => {
      state.preCheckList = action.payload;
    },
    updatePreCheckPagination: (state, action) => {
      state.preCheckPagination = { ...state.preCheckPagination, ...action.payload };
    },
    updatePreCheckObj: (state, action) => {
      state.lastPreCheckObj = action.payload;
    },
    dockConflictDetailsReducer: (state, action) => {
      state.dockConflictObj = action.payload;
    },
    updateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    updateDockTypeList: (state, action) => {
      state.dockTypeList = action.payload;
    },
    resetMetaDocksList: (state, action) => {
      state.whMetaDocksList = action.payload;
    },
    updateCapacityManagementList: (state, action) => {
      state.capacityManagementList = action.payload;
    },
    getMassCancelReason: (state, action) => {
      state.massCancelReasonList = action.payload;
    },
    resetMassCancelReason: (state) => {
      state.massCancelReasonList = [];
    },
  },
});

export const {
  getWhMetaDockList,
  updateOperationObj,
  getWhMetaLeavesList,
  getWhMetaBreaksList,
  getWhMetaCapacityList,
  getWhMetaTimeslotList,
  updateTableData,
  updatePreCheckList,
  updatePreCheckPagination,
  updatePreCheckObj,
  dockConflictDetailsReducer,
  updateIsLoading,
  updateDockTypeList,
  resetMetaDocksList,
  updateCapacityManagementList,
  getMassCancelReason,
  resetMassCancelReason,
} = WhMetaDataReducerSlice.actions;

// Selectors
export const getWhMetaDataReducerSlice = (state) => {
    return state.whMetaDataReducerSlice
};


export default WhMetaDataReducerSlice.reducer;
